import React from "react";
import { getValidationEmail } from "./gateway";
import { useQuery } from "react-query";

function useValidateEmail({ token }: { token: string }) {
  return useQuery({
    queryFn: () => getValidationEmail(token),
    queryKey: "validate-email",
  });
}

export default useValidateEmail;
